import type { DisplayOptions } from "@/pages/human-resources/time-management/model/display-options/DisplayOptions.ts";
import { createContext } from "react";

export const DisplayOptionsContext = createContext<DisplayOptions | undefined>(
  undefined,
);
